<script setup>
import ClassicAuthCard from '../components/ClassicAuthCard.vue'

defineProps({
  loginUrl: { type: String, default: '/login' },
  practiceUrl: { type: String, default: '/register-practice' },
  patientUrl: { type: String, default: '/register-patient' },
})

const showPatientRegistration = false
</script>

<template>
  <ClassicAuthCard
    title="Registration"
    subtitle="Register your practice"
    :footer-link-url="loginUrl"
    footer-link-label="Login"
  >
    <nav class="classic-registration" aria-label="Practice registration">
      <a class="classic-registration__button classic-registration__button--practice" :href="practiceUrl">
        Practice
      </a>
      <a
        v-if="showPatientRegistration"
        class="classic-registration__button classic-registration__button--patient"
        :href="patientUrl"
      >
        Patient
      </a>
    </nav>
  </ClassicAuthCard>
</template>

<style scoped>
.classic-registration {
  display: grid;
  gap: 16px;
}

.classic-registration__button {
  border-radius: 24px;
  color: #fff;
  display: block;
  font-size: 16px;
  font-weight: 500;
  padding: 12px 24px;
  text-align: center;
  text-decoration: none;
}

.classic-registration__button--practice {
  background: #ff7f5d;
}

.classic-registration__button--patient {
  background: #ffc05d;
}

.classic-registration__button:focus-visible {
  outline: 3px solid rgba(86, 68, 149, 0.3);
  outline-offset: 3px;
}
</style>
